document.addEventListener('DOMContentLoaded', () => {
  const supportsMouse =
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const prefersReducedMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!supportsMouse || prefersReducedMotion) return;

  const canvas = document.createElement('canvas');
  canvas.id = 'mablu-cursor-trail';
  canvas.setAttribute('aria-hidden', 'true');
  document.body.appendChild(canvas);

  const context = canvas.getContext('2d');

  if (!context) return;

  let width = window.innerWidth;
  let height = window.innerHeight;
  let pixelRatio = Math.min(window.devicePixelRatio || 1, 2);

  let particles = [];
  let animationFrame = null;
  let lastX = null;
  let lastY = null;

  /*
   * PERSONALIZACIÓN
   *
   * Cambia estos valores para modificar el efecto.
   */
  const settings = {
  color: '155, 204, 247',
  opacity: 0.50,
  minimumSize: 2,
  maximumSize: 7,
  lifetime: 34,
  minimumDistance: 8,
  maximumParticles: 45
};

  const resizeCanvas = () => {
    width = window.innerWidth;
    height = window.innerHeight;
    pixelRatio = Math.min(window.devicePixelRatio || 1, 2);

    canvas.width = width * pixelRatio;
    canvas.height = height * pixelRatio;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
  };

  const createParticle = (x, y, movementX, movementY) => {
    const size =
      settings.minimumSize +
      Math.random() * (settings.maximumSize - settings.minimumSize);

    particles.push({
      x: x + (Math.random() - 0.5) * 4,
      y: y + (Math.random() - 0.5) * 4,
      size,
      life: settings.lifetime,
      maximumLife: settings.lifetime,
      velocityX: movementX * 0.025 + (Math.random() - 0.5) * 0.15,
      velocityY: movementY * 0.025 + (Math.random() - 0.5) * 0.15
    });

    if (particles.length > settings.maximumParticles) {
      particles.splice(
        0,
        particles.length - settings.maximumParticles
      );
    }
  };

  const handlePointerMove = (event) => {
    const x = event.clientX;
    const y = event.clientY;

    if (lastX === null || lastY === null) {
      lastX = x;
      lastY = y;
      return;
    }

    const movementX = x - lastX;
    const movementY = y - lastY;
    const distance = Math.hypot(movementX, movementY);

    if (distance < settings.minimumDistance) return;

    const particleQuantity = Math.min(
      Math.ceil(distance / 14),
      3
    );

    for (let index = 0; index < particleQuantity; index += 1) {
      const progress = index / particleQuantity;

      createParticle(
        lastX + movementX * progress,
        lastY + movementY * progress,
        movementX,
        movementY
      );
    }

    lastX = x;
    lastY = y;

    if (!animationFrame) {
      animationFrame = requestAnimationFrame(animate);
    }
  };

  const handlePointerLeave = () => {
    lastX = null;
    lastY = null;
  };

  const animate = () => {
    context.clearRect(0, 0, width, height);

    particles = particles.filter((particle) => particle.life > 0);

    particles.forEach((particle) => {
      particle.life -= 1;
      particle.x += particle.velocityX;
      particle.y += particle.velocityY;
      particle.size *= 0.985;

      const lifeProgress =
        particle.life / particle.maximumLife;

      const opacity =
        settings.opacity *
        Math.pow(lifeProgress, 1.7);

      context.beginPath();
      context.arc(
        particle.x,
        particle.y,
        Math.max(particle.size, 0.5),
        0,
        Math.PI * 2
      );

      context.fillStyle =
        `rgba(${settings.color}, ${opacity})`;

      context.fill();
    });

    if (particles.length > 0) {
      animationFrame = requestAnimationFrame(animate);
    } else {
      animationFrame = null;
    }
  };

  resizeCanvas();

  window.addEventListener('resize', resizeCanvas);
  window.addEventListener('pointermove', handlePointerMove, {
    passive: true
  });
  document.documentElement.addEventListener(
    'mouseleave',
    handlePointerLeave
  );
});